@let firstProblemId = firstProblemId$ | async;
@let appMode = appMode$ | async;
@let browsing = appMode === 'browse';
@let adding = appMode === 'add';
@let editing = appMode === 'edit';

<div class="row mb-4">
    <div class="d-flex flex-column col-4 gap-2">
        @if (browsing) {
        <div class="card text-bg-light p-3">
            <la-navigator />
            <la-search />
        </div>
        } @else if (adding || editing) {
        <section class="d-flex flex-column gap-2">
            @if (adding) {
            <p class="text-muted" i18n>
                You are currently adding a new problem.
            </p>
            } @else {
            <p class="text-muted" i18n>
                You are currently editing an existing problem.
            </p>
            }
            <p class="text-muted" i18n>
                Hit 'Start Parse' to send your problem data to the parser and
                inspect the results.
            </p>
            <p class="text-muted" i18n>
                If you are happy with the changes, save the problem by clicking
                the 'Save problem' button.
            </p>
            @if (adding) {
            <p class="text-muted" i18n>
                This will add the problem to the database.
            </p>
            } @else {
            <p class="text-muted" i18n>
                This will update this problem in the database.
            </p>
            } @if (firstProblemId) {
            <a
                class="btn btn-secondary d-flex align-items-center justify-content-center"
                [routerLink]="['/', 'annotate', firstProblemId.toString()]"
            >
                <fa-icon
                    [icon]="faBinoculars"
                    aria-hidden="true"
                    focusable="false"
                ></fa-icon>
                <span class="ms-3" i18n>Browse existing problems</span>
            </a>
            }
        </section>
        } @else {
        <section class="d-flex justify-content-center align-items-center">
            <div class="spinner-border spinner-border-lg">
                <span class="visually-hidden" i18n>Loading...</span>
            </div>
        </section>
        }
        <div class="d-flex flex-column gap-2 align-items-stretch">
            @if (browsing && (canCreateProblem$ | async)) {
            <a
                class="btn btn-secondary d-flex align-items-center justify-content-center"
                [routerLink]="['/', 'annotate', 'new']"
            >
                <fa-icon
                    [icon]="faPlus"
                    aria-hidden="true"
                    focusable="false"
                ></fa-icon>
                <span class="ms-3" i18n>Add new problem</span>
            </a>
            }
            @if (appMode === 'browse' && (canCopyProblem$ | async)) {
            <a
                class="btn btn-secondary d-flex align-items-center justify-content-center"
                [routerLink]="['/', 'annotate', 'new']"
                [queryParams]="{base: currentProblemId$ | async }"

            >
                <fa-icon
                    [icon]="faCopy"
                    class="fa-md"
                    aria-hidden="true"
                    focusable="false"
                />
                <span class="ms-2" i18n>Copy problem</span>
            </a>
            }
            @if ((isUserProblem$ | async) && (canEditProblem$ | async)) {
            <a
                class="btn btn-secondary d-flex align-items-center justify-content-center"
                [routerLink]="['./edit']"
                queryParamsHandling="preserve"
            >
                <fa-icon
                    [icon]="faWrench"
                    aria-hidden="true"
                    focusable="false"
                ></fa-icon>
                <span class="ms-3" i18n>Edit problem</span>
            </a>
            }
        </div>
    </div>
    <la-annotation-input class="col-8" />
</div>
<la-annotation-menu />
